<template>
  <div>
    <el-dialog destroy-on-close title="导出设置" v-model="dialogFormVisibleManager" :close-on-click-modal="false" class="button_bg">
      <el-form :model="temp" class="print_box" label-width="100px" label-position="right">
        <!-- <el-form-item label="科目:" v-if="this.name == book_diary_account">
          <subject-list-all v-model:subjectId="listQuery1.subjectId" :codes="$findCode(this.code)" clear></subject-list-all>
          <span style="color:red;font-size: 20px;vertical-align: middle;">*</span><span style="color:red">不选默认打印全部</span>
        </el-form-item> -->
        <el-form-item label="科目:">
          <subject-list-all v-model:subjectId="listQuery1.subjectId" clear></subject-list-all>
          <span style="color:red;font-size: 20px;vertical-align: middle;">*</span><span style="color:red">不选默认导出全部</span>
        </el-form-item>
        <el-form-item label="科目选择：" class="item_row" v-if="name == 'book_detail_account'">
          <el-radio-group v-model="temp.level">
            <el-radio :label="0">默认</el-radio>
            <el-radio :label="1">一级</el-radio>
            <el-radio :label="2">二级</el-radio>
            <el-radio :label="3">三级</el-radio>
            <el-radio :label="4">四级</el-radio>
            <el-radio :label="5">五级</el-radio>
            <el-radio :label="100">最下级科目</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="规则：" class="item_row" v-if="name == 'book_detail_account'">
          <el-radio-group v-model="temp.merge">
            <el-radio :label="0">默认</el-radio>
            <el-radio :label="1">合并</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFormVisibleManager = false" size="mini">取消</el-button>
          <el-button type="primary" @click="print()" size="mini">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { printSetOne,exportBook } from "@/api/printSet";
export default {
  name:'exportFile',
  props: {
    name: {
      type: String,
      default: ""
    },
    listQuery1: {
      type: Object,
    },
    code: {
      type: Array,
    }
  },
  data () {
    return {
      temp:{
        level:0,
        radio:0,
        merge:0,
      },
      dialogFormVisibleManager: false
    };
  },
  methods: {
    init(){
      // this.initTemp()
      this.dialogFormVisibleManager = true
      printSetOne({type:'excel', bookNames:this.name}).then(res=>{
        this.temp = res.data.data.info?res.data.data.info:this.temp
        this.temp.type = "excel"
      })
    },
    // 导出
    print(){
      let params = Object.assign({}, this.temp)
      params.query = this.listQuery1
      params.comIds = [this.listQuery1.comId]
      // params.comIds = [ this.$store.getters['user/comInfo'].comId*1]
      params.bookNames = [this.name]
      params.paperType = "A4-H"
      if(this.listQuery1.endTime < this.listQuery1.beginTime) {
        this.$message({
          showClose: true,
          message: '请查看日期起止是否填写正确',
          type: 'warning'
        });
        return
      }
      exportBook(params).then(res=>{
        if (res.data.data.url) {
          window.open(res.data.data.url); 
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>

</style>


